module.exports = __webpack_public_path__ + "static/media/intell-chassis.761f9c91.png";